var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorAgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#EC6655"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 2.37221L4.90942 5.68595C4.90942 5.89564 5.03063 6.00049 5.27305 6.00049H6.7276C6.97002 6.00049 7.09123 5.89564 7.09123 5.68595L7.33366 2.37221C7.33366 2.25784 7.29326 2.17205 7.21245 2.11486C7.15184 2.03861 7.07103 2.00049 6.97002 2.00049H5.03063C4.92962 2.00049 4.83871 2.03861 4.7579 2.11486C4.6973 2.17205 4.66699 2.25784 4.66699 2.37221Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00033 7.33398C6.36748 7.33398 6.67665 7.46925 6.92786 7.73978C7.19839 7.99099 7.33366 8.30017 7.33366 8.66732C7.33366 9.03447 7.19839 9.35331 6.92786 9.62384C6.67665 9.87505 6.36748 10.0007 6.00033 10.0007C5.63318 10.0007 5.31434 9.87505 5.0438 9.62384C4.7926 9.35331 4.66699 9.03447 4.66699 8.66732C4.66699 8.30017 4.7926 7.99099 5.0438 7.73978C5.31434 7.46925 5.63318 7.33398 6.00033 7.33398Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorAgIcon);
export default __webpack_public_path__ + "static/media/error-ag-icon.0113463f31d5b8d8eae4ef7e5900281a.svg";
export { ForwardRef as ReactComponent };